module.exports = __webpack_public_path__ + "img/downloadcredentials.940285c8.png";